import React, { useMemo, useState } from 'react';
import { CustomerUser } from '@ansvar-sakerhet/api-client';
import { S } from './CustomerUsersList.styles';
import { CustomerUsersTable } from './component/CustomerUsersTable';
import { Loading } from '../../../../../../../../../components/Loading';
import {
  SortCustomerUsers,
  useGetAllCustomerUsersOnClient,
} from '../../../../../../../../../traits/api/customerUsers/useGetAllCustomerUsersOnClient';
import { AddCustomerUserModal } from './component/AddCustomerUserModal';
import { EditCustomerUserModal } from './component/EditCustomerUserModal';
import { Pagination } from '../../../../../../../../../components/Pagination';
import { SearchInput } from '../../../../../../../../../components/SearchInput';
import { CustomerUsersSortDropdown } from './component/CustomerUsersSortDropdown/CustomerUsersSortDropdown';

type Props = {
  clientId: string;
};

export const CustomerUsersList = ({ clientId }: Props) => {
  const [page, setPage] = useState(0);
  const entitiesPerPage = 10;
  const pagination = useMemo(
    () => ({
      skip: entitiesPerPage * page,
      take: entitiesPerPage,
    }),
    [page]
  );

  const [search, setSearch] = useState('');
  const [sort, setSort] = useState<SortCustomerUsers | undefined>(undefined);

  const {
    data: customerUsers,
    isLoading,
    count,
  } = useGetAllCustomerUsersOnClient(
    clientId,
    pagination.take,
    pagination.skip,
    sort,
    search
  );
  const [modalOpen, setModalOpen] = useState(false);
  const [editingUser, setEditingUser] = useState<CustomerUser | null>(null);

  if (isLoading || !customerUsers) {
    return <Loading />;
  }

  return (
    <>
      <S.Flex $justify="between" $align="center" $gap={16} $flexWrap="wrap">
        <S.Flex $align="center" $gap={16} $flexWrap="wrap">
          <SearchInput
            input={search}
            setInput={setSearch}
            placeholder="Sök efter namn"
          />
          <CustomerUsersSortDropdown sort={sort} setSort={setSort} />
        </S.Flex>
        <S.Button onClick={() => setModalOpen(true)}>
          <S.Icon src="Plus" /> Skapa ny kund-användare
        </S.Button>
      </S.Flex>
      <CustomerUsersTable
        customerUsers={customerUsers}
        onEdit={setEditingUser}
      />
      <S.Margin $top="m" />
      <Pagination
        numberOfPages={Math.ceil(count / entitiesPerPage)}
        page={page}
        setPage={setPage}
      />
      <AddCustomerUserModal
        chosenClientId={clientId}
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
      />
      <EditCustomerUserModal
        user={editingUser}
        clientId={clientId}
        open={Boolean(editingUser)}
        onCancel={() => setEditingUser(null)}
      />
    </>
  );
};
